import { __awaiter } from 'tslib';
import axios from 'axios';
import { IMHttpClient } from '../abstract/IMHttpClient.js';

class BrowserHttpClient extends IMHttpClient {
    constructor(ctx) {
        super(ctx);
        this.instance = axios.create({
            timeout: this.option.timeout,
            withCredentials: !!this.option.withCredentials,
            headers: this.headers,
            responseType: this.dataType,
            method: this.method
        });
    }
    send(url, method, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.instance.request({
                url,
                data: data,
                method
            });
            return res.data;
        });
    }
    sendByBeacon(url, data) {
        if (navigator.sendBeacon !== undefined) {
            return navigator.sendBeacon(url, data);
        }
        return false;
    }
}

export { BrowserHttpClient };
//# sourceMappingURL=BrowserHttpClient.js.map
